import { createRouter as createVueRouter, createWebHistory } from 'vue-router';

import HomePage from '@/components/HomePage.vue';
import InvitePage from '@/components/InvitePage.vue';

import sentry from '../analytics/sentry';
import { loadLocale } from '../i18n';

const routes = [{
    path: '/',
    name: 'home',
    component: HomePage,
},
{
    path: '/invite',
    name: 'invite',
    component: InvitePage,
}];

export const createRouter = () => {
    const router = createVueRouter({
        history: createWebHistory(),
        routes,
    });

    router.beforeEach(async () => {
        try {
            await loadLocale();
        } catch (e) {
            sentry.captureException(e);
        }
    });

    return router;
};
